"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function GoogleworkspaceGreyMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__googleworkspace-grey-multitone-filled__clip0_14202_8729)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9ECEF",
    d: "M8.16 7.276h7.277c.04.161.08.362.12.603.041.242.041.443.041.684 0 .924-.16 1.809-.442 2.653-.282.844-.764 1.568-1.367 2.211-.643.684-1.447 1.206-2.372 1.608-.924.362-1.97.563-3.176.563a8.586 8.586 0 01-3.055-.563c-.965-.362-1.769-.925-2.492-1.568-.724-.683-1.247-1.487-1.689-2.412C.603 10.131.402 9.125.402 8c0-1.085.201-2.09.603-3.055.442-.925 1.005-1.729 1.689-2.372a7.288 7.288 0 012.492-1.568A7.816 7.816 0 018.241.402c1.206 0 2.292.201 3.216.603a7.04 7.04 0 012.453 1.688l-1.93 1.85c-.482-.483-1.005-.885-1.608-1.166-.603-.282-1.286-.402-2.13-.402-.684 0-1.327.12-1.93.362a5.158 5.158 0 00-1.608 1.005A5.458 5.458 0 003.618 5.91c-.281.603-.402 1.286-.402 2.05 0 .764.12 1.447.402 2.05a5.46 5.46 0 001.086 1.568 5.158 5.158 0 001.608 1.005 5.147 5.147 0 001.93.362c.803 0 1.447-.12 2.01-.322a5.933 5.933 0 001.406-.844c.282-.241.523-.563.724-.925a5.74 5.74 0 00.482-1.246H8.161V7.276z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED4DA",
    d: "M9.568 7.276L8.16 8.844V7.276h1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED4DA",
    d: "M13.83 2.613l-1.167 1.286-.683.644a6.3 6.3 0 00-1.608-1.166 5.59 5.59 0 00-2.13-.402c-.684 0-1.327.12-1.93.362a5.158 5.158 0 00-1.608 1.005A5.458 5.458 0 003.618 5.91c-.281.603-.402 1.286-.402 2.05 0 .764.12 1.447.402 2.05a5.46 5.46 0 001.086 1.568c.16.16.361.322.562.442l-1.809 2.01c-.24-.2-.522-.402-.763-.603a8.662 8.662 0 01-1.689-2.412C.603 10.09.402 9.085.402 7.96c0-1.126.201-2.09.603-3.015.442-.925 1.005-1.729 1.689-2.372a7.288 7.288 0 012.492-1.568A7.816 7.816 0 018.241.402c1.206 0 2.292.201 3.216.603a7.5 7.5 0 012.372 1.608z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.241 16a8.629 8.629 0 01-3.216-.603 8.265 8.265 0 01-2.613-1.648 8.693 8.693 0 01-1.769-2.533C.201 10.251 0 9.166 0 8c0-1.166.241-2.211.643-3.216a8.693 8.693 0 011.77-2.533A7.06 7.06 0 015.024.603 8.629 8.629 0 018.241 0c1.246 0 2.372.201 3.377.643a8.376 8.376 0 012.573 1.77c.16.16.16.401 0 .562l-1.93 1.85a.389.389 0 01-.563 0 5.266 5.266 0 00-1.487-1.046c-.523-.241-1.206-.362-1.97-.362-.643 0-1.206.12-1.769.322a3.889 3.889 0 00-1.447.924A4.665 4.665 0 004.02 6.111 4.797 4.797 0 003.658 8c0 .683.12 1.327.362 1.89a4.664 4.664 0 001.005 1.447c.442.402.925.723 1.488.924a5.347 5.347 0 001.809.322c.723 0 1.366-.12 1.849-.322a4.645 4.645 0 001.286-.804c.241-.2.442-.482.643-.804.121-.2.202-.442.282-.643H8.16c-.241 0-.402-.16-.402-.402V7.276c0-.24.16-.402.402-.402h7.276c.201 0 .362.121.402.322.04.16.08.402.12.643.041.241.041.483.041.724 0 .965-.16 1.89-.442 2.774a6.857 6.857 0 01-1.447 2.372c-.684.723-1.528 1.286-2.533 1.688-1.005.402-2.09.603-3.337.603zm0-15.196c-1.005 0-2.01.201-2.894.523-.925.361-1.689.884-2.372 1.527-.684.643-1.206 1.407-1.608 2.292A6.86 6.86 0 00.764 8c0 1.045.2 2.01.603 2.854.402.885.924 1.649 1.608 2.292a7.195 7.195 0 002.372 1.487c.884.362 1.89.523 2.894.523 1.126 0 2.13-.201 3.015-.523.885-.362 1.608-.884 2.252-1.527a6.09 6.09 0 001.286-2.05c.281-.764.402-1.609.402-2.493 0-.201 0-.442-.04-.643 0-.08-.04-.161-.04-.242H8.563v1.528h4.261c.12 0 .241.04.322.16.08.081.12.242.08.363-.12.482-.281.924-.523 1.326-.24.402-.482.764-.803 1.046a5.156 5.156 0 01-1.528.924c-.603.241-1.327.362-2.171.362-.724 0-1.447-.12-2.09-.402A4.847 4.847 0 014.38 11.9a6.439 6.439 0 01-1.205-1.689C2.935 9.568 2.814 8.804 2.814 8c0-.804.16-1.568.442-2.211.282-.643.684-1.246 1.166-1.688a4.847 4.847 0 011.729-1.086 6.04 6.04 0 012.09-.402c.885 0 1.648.16 2.292.442a5.686 5.686 0 011.447.965l1.367-1.286c-.563-.563-1.246-.965-2.01-1.327-.925-.402-1.97-.603-3.096-.603z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__googleworkspace-grey-multitone-filled__clip0_14202_8729"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

GoogleworkspaceGreyMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
GoogleworkspaceGreyMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = GoogleworkspaceGreyMultitoneFilled;
exports["default"] = _default;